// extracted by mini-css-extract-plugin
export default {"body":"CommentNotificationBody-body-86deafc705683c1db760215d7430e131"};